import { Container, styled } from "ol-components"

const VideoContainer = styled(Container)(({ theme }) => ({
  maxWidth: "1080px !important",
  padding: "0 !important",
  [theme.breakpoints.down("lg")]: {
    padding: "0 16px !important",
  },
  [theme.breakpoints.down("md")]: {
    padding: "0 16px !important",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "0 16px !important",
  },
}))

export default VideoContainer
